import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useSnackBar } from '../../hooks/useSnackBar';
import { useTranslation } from '../../hooks/useTranslation';

const CalendarSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const showSnackBar = useSnackBar();
  const { t } = useTranslation();

  useEffect(() => {
    const agentId = searchParams.get('agent_id');

    showSnackBar(t('Calendar connected successfully!'), 'success');

    const timer = setTimeout(() => {
      if (agentId) {
        navigate(`/agents/call/edit/${agentId}?step=2`);
      } else {
        navigate('/agents/call/new');
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, searchParams, showSnackBar]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {t('Calendar Connected Successfully!')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {searchParams.get('agent_id')
          ? t('Redirecting back to agent edit...')
          : t('Redirecting back to agent creation...')}
      </Typography>
    </Box>
  );
};

export default CalendarSuccess;
